import { SVGIconComponent } from './types';

export const Space: SVGIconComponent = ({ color, className, style }) => {
  return (
    <svg
      width="24px"
      height="34px"
      viewBox="0 0 24 34"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={{ color, ...style }}
      className={className}
    >
      <g id="Hubs-Lockers" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-Copy" transform="translate(-56, 1)" fillRule="nonzero">
          <g id="Locker-Sizes/space" transform="translate(57, 0)">
            <path
              d="M21.1713801,32 C21.6292299,32 22,31.568528 22,31.0357667 L22,0.964229967 C22,0.431449448 21.6292134,0 21.1713801,0 L0.828619891,0.00187630565 C0.370770052,0 0,0.433344964 0,0.964233328 L0,31.03577 C0,31.5704235 0.37078656,32 0.828619891,32 L21.1713801,32 Z"
              id="Shape"
              stroke="currentColor"
              strokeWidth="1.5"
            ></path>
            <g
              id="Group"
              transform="translate(10.9998, 16.0001) rotate(-60.5) translate(-10.9998, -16.0001)translate(-0.0667, 15.0002)"
              fill="currentColor"
            >
              <path
                d="M9.11540871,2.24258537 C9.65406617,2.24258537 10.0896881,1.82280576 10.0896881,1.30614121 L10.0896881,0.744258174 C10.0896881,0.226518961 9.65294809,-0.192185991 9.11540871,-0.192185991 C8.57675124,-0.192185991 8.14112718,0.227593623 8.14112718,0.744258174 L8.14112718,1.30614121 C8.14000924,1.82388042 8.57675124,2.24258537 9.11540871,2.24258537 Z"
                id="Path-Copy-4"
                transform="translate(9.1154, 1.0252) rotate(90) translate(-9.1154, -1.0252)"
              ></path>
              <path
                d="M16.9823365,2.24284637 C17.520994,2.24284637 17.9566159,1.82306675 17.9566159,1.3064022 L17.9566159,0.744519169 C17.9566159,0.226779956 17.5198759,-0.191924996 16.9823365,-0.191924996 C16.4436791,-0.191924996 16.008055,0.227854618 16.008055,0.744519169 L16.008055,1.3064022 C16.0069371,1.82414141 16.4436791,2.24284637 16.9823365,2.24284637 Z"
                id="Path-Copy-5"
                transform="translate(16.9823, 1.0255) rotate(90) translate(-16.9823, -1.0255)"
              ></path>
              <path
                d="M5.15096369,2.19198455 C5.68962115,2.19198455 6.12524306,1.77220493 6.12524306,1.25554038 L6.12524306,0.69365735 C6.12524306,0.175918137 5.68850307,-0.242786815 5.15096369,-0.242786815 C4.61230622,-0.242786815 4.17668179,0.176992799 4.17668179,0.69365735 L4.17668179,1.25554038 C4.17556422,1.7732796 4.61230622,2.19198455 5.15096369,2.19198455 Z"
                id="Path-Copy-9"
                transform="translate(5.151, 0.9746) rotate(90) translate(-5.151, -0.9746)"
              ></path>
              <path
                d="M13.0487598,2.24253204 C13.5874172,2.24253204 14.0230391,1.82275243 14.0230391,1.30608788 L14.0230391,0.744204847 C14.0230391,0.226465634 13.5862992,-0.192239318 13.0487598,-0.192239318 C12.5101023,-0.192239318 12.0744782,0.227540296 12.0744782,0.744204847 L12.0744782,1.30608788 C12.0733603,1.82275243 12.5101023,2.24253204 13.0487598,2.24253204 Z"
                id="Path-Copy-6"
                transform="translate(13.0488, 1.0251) rotate(90) translate(-13.0488, -1.0251)"
              ></path>
              <path
                d="M1.21738889,2.19166827 C1.75604636,2.19166827 2.19166827,1.77188866 2.19166827,1.25522411 L2.19166827,0.693341074 C2.19166827,0.175601861 1.75492827,-0.243103091 1.21738889,-0.243103091 C0.67873143,-0.243103091 0.243103091,0.176676523 0.243103091,0.693341074 L0.243103091,1.25522411 C0.241989427,1.77188866 0.67873143,2.19166827 1.21738889,2.19166827 Z"
                id="Path-Copy-10"
                transform="translate(1.2174, 0.9743) rotate(90) translate(-1.2174, -0.9743)"
              ></path>
              <path
                d="M20.9156124,2.24267049 C21.4542698,2.24267049 21.8898917,1.82289088 21.8898917,1.30622632 L21.8898917,0.744343292 C21.8898917,0.226604079 21.4531517,-0.192100873 20.9156124,-0.192100873 C20.3769549,-0.192100873 19.9413308,0.227678742 19.9413308,0.744343292 L19.9413308,1.30622632 C19.9402129,1.82289088 20.3769549,2.24267049 20.9156124,2.24267049 Z"
                id="Path-Copy-7"
                transform="translate(20.9156, 1.0253) rotate(90) translate(-20.9156, -1.0253)"
              ></path>
            </g>
            <path
              d="M17.5088774,5.5 C18.0568471,5.5 18.5,5.02670973 18.5,4.4441843 L18.4822452,1.5558157 C18.4822452,0.972078612 18.0379549,0.5 17.4911226,0.5 C16.9431529,0.5 16.5,0.973290265 16.5,1.5558157 L16.5177548,4.4441843 C16.5166153,5.02792139 16.9609077,5.5 17.5088774,5.5 Z"
              id="Path-Copy"
              fill="currentColor"
              transform="translate(17.5, 3) rotate(90) translate(-17.5, -3)"
            ></path>
            <path
              d="M19.0088774,7 C19.5568471,7 20,6.52670973 20,5.9441843 L20.0033245,3.054775 C20.0033245,2.47103791 19.5379549,2 18.9911226,2 C18.4431529,2 18,2.47329027 18,3.0558157 L18.0177548,5.9441843 C18.0166153,6.52792139 18.4609077,7 19.0088774,7 Z"
              id="Path-Copy"
              fill="currentColor"
            ></path>
            <g
              id="Group-21"
              transform="translate(4.5017, 27.5) rotate(180) translate(-4.5017, -27.5)translate(2, 25)"
              fill="currentColor"
            >
              <path
                d="M2.5088774,3.5 C3.05684711,3.5 3.5,3.02670973 3.5,2.4441843 L3.4822452,-0.4441843 C3.4822452,-1.02792139 3.0379549,-1.5 2.4911226,-1.5 C1.94315289,-1.5 1.5,-1.02670973 1.5,-0.4441843 L1.5177548,2.4441843 C1.51661534,3.02792139 1.96090769,3.5 2.5088774,3.5 Z"
                id="Path-Copy"
                transform="translate(2.5, 1) rotate(90) translate(-2.5, -1)"
              ></path>
              <path
                d="M4.0088774,5 C4.55684711,5 5,4.52670973 5,3.9441843 L5.00332451,1.054775 C5.00332451,0.471037912 4.5379549,0 3.9911226,0 C3.44315289,0 3,0.473290265 3,1.0558157 L3.0177548,3.9441843 C3.01661534,4.52792139 3.46090769,5 4.0088774,5 Z"
                id="Path-Copy"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
